function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 13 13",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M8.527 2.097l-.48 2.236h3.096c1.026 0 1.857.832 1.857 1.857v1.892c0 .385-.09.764-.261 1.108l-1.083 2.164a1.857 1.857 0 01-1.66 1.027H1.237A1.238 1.238 0 010 11.143V6.19c0-.683.554-1.238 1.238-1.238h1.857L5.851.543C6.062.205 6.433 0 6.83 0a1.734 1.734 0 011.696 2.097zM3.095 6.19H1.238v4.953h1.857V6.19zm7.454 4.61a.619.619 0 01-.554.343H4.333V5.307L6.875 1.24a.496.496 0 01.441.598l-.479 2.236a1.238 1.238 0 001.21 1.497h3.096c.342 0 .619.278.619.62v1.891c0 .192-.045.382-.13.554L10.548 10.8z"
}));